import { Inject, Injectable } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { NavigationStart, Router } from '@angular/router';
import { filter } from 'rxjs/operators';

// JSON-LD (schema.org) wstrzykiwany do <head>. Dziala takze w SSR -
// crawlery (Google, LLM-y) dostaja dane strukturalne bez wykonywania JS.
// Schematy per-page sa czyszczone przy kazdej nawigacji; globalne
// (Organization/WebSite) zyja przez caly czas.

const ATTR = 'data-sc-schema';

@Injectable({ providedIn: 'root' })
export class SchemaService {
  constructor(
    @Inject(DOCUMENT) private document: Document,
    private router: Router
  ) {
    this.router.events
      .pipe(filter(e => e instanceof NavigationStart))
      .subscribe(() => this.clearPageSchemas());
  }

  /** Schemat globalny - nie jest czyszczony przy nawigacji. */
  setGlobal(id: string, schema: object) {
    this.set(`global-${id}`, schema);
  }

  /** Schemat strony - znika przy przejsciu na inna trase. */
  setForPage(id: string, schema: object) {
    this.set(`page-${id}`, schema);
  }

  clear(id: string) {
    const existing = this.document.head.querySelector(
      `script[${ATTR}="page-${id}"], script[${ATTR}="global-${id}"]`
    );
    if (existing) {
      existing.remove();
    }
  }

  private set(key: string, schema: object) {
    let script = this.document.head.querySelector(
      `script[${ATTR}="${key}"]`
    ) as HTMLScriptElement;

    if (!script) {
      script = this.document.createElement('script');
      script.setAttribute('type', 'application/ld+json');
      script.setAttribute(ATTR, key);
      this.document.head.appendChild(script);
    }

    script.textContent = JSON.stringify({
      '@context': 'https://schema.org',
      ...schema
    });
  }

  private clearPageSchemas() {
    const scripts = this.document.head.querySelectorAll(
      `script[${ATTR}^="page-"]`
    );
    for (let i = 0; i < scripts.length; i++) {
      scripts[i].remove();
    }
  }
}
